export default __webpack_public_path__ + "static/media/vocab_dark.8020db65.svg";